import { useTranslations } from '@vocab/react';
import { Box } from 'braid-design-system';
import { vars } from 'braid-design-system/css';
import { useRef } from 'react';

import type { Qualification } from 'src/__generated__/graphql';
import { EducationEditor } from 'src/components/Education/EducationEditor';
import { EducationList } from 'src/components/Education/EducationList';
import {
  EditorDrawerProvider,
  EditorDrawer,
} from 'src/ui/EditorDrawer/EditorDrawer';

import translations from './.vocab';
import { useEducationData } from './hooks/useEducationData';

interface Props {
  unconfirmedQualifications: Qualification[];
}

export default function Education({ unconfirmedQualifications }: Props) {
  const { t } = useTranslations(translations);
  const scrollRef = useRef<HTMLDivElement>(null);
  const { qualifications } = useEducationData();

  return (
    <EditorDrawerProvider name="education">
      <Box
        data={{ automation: 'education-section' }}
        ref={scrollRef}
        style={{ scrollMarginTop: vars.space.xxlarge }} // offset for the Stack wrapping this component
      >
        <EducationList
          // @ts-expect-error isVerified mismatch
          qualifications={qualifications}
          unconfirmedQualifications={unconfirmedQualifications}
          shouldShowHeader
          shouldShowPrompt
        />
      </Box>
      <EditorDrawer
        title={t('Education')}
        name="education"
        onClose={() => {
          scrollRef.current?.scrollIntoView?.({
            behavior: 'smooth',
            block: 'start',
          });
        }}
      >
        <EducationEditor
          shouldCloseDrawerOnExit
          // @ts-expect-error isVerified mismatch
          qualifications={qualifications}
          unconfirmedQualifications={unconfirmedQualifications}
        />
      </EditorDrawer>
    </EditorDrawerProvider>
  );
}
